import { Box } from "@mui/material";
import { IndustryWithCompanies } from "services/hooks/useCompanies";
import Company from "./Company";
import CompanyGroup from "./CompanyGroup";

interface CompaniesProps {
  industriesRows: IndustryWithCompanies[][];
}

const Companies: React.FC<CompaniesProps> = ({ industriesRows }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2.5}>
      {industriesRows.map((row, rowIndex) => (
        <Box key={rowIndex} display="flex" gap={2.5} flexWrap="nowrap">
          {row.map((industry, industryIndex) => {
            const companies = industry.companies;

            return (
              <CompanyGroup
                key={`${rowIndex}-${industryIndex}`}
                companyCount={companies.length}
                title={industry.name}
              >
                {companies.map((company, companyIndex) => (
                  <Company
                    key={`${rowIndex}-${industryIndex}-${companyIndex}`}
                    company={company}
                    companyCount={companies.length}
                  />
                ))}
              </CompanyGroup>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

export default Companies;
